export const REPORTS_ALLOWED_SHOP_IDS = [4, 23];

export interface SalesReportFilters {
  shopId: number;
  startDate?: string;
  endDate?: string;
  minAmount?: number | string;
  maxAmount?: number | string;
  saleState?: number | string;
  paymentTypeId?: number | string;
  paymentTypeMode?: number | string;
  shopPointId?: number | string;
  shopCompanyId?: number | string;
  productPaymentMode?: number | string;
  searchString?: string;
}

export interface SalesReportSummary {
  totalSales?: number | string | null;
  totalClients?: number | string | null;
  totalAssociations?: number | string | null;
  totalPrincipalAmount?: number | string | null;
  totalDiscountAmount?: number | string | null;
  totalNetAmount?: number | string | null;
  totalMonthlyInstallment?: number | string | null;
  totalPaidAmount?: number | string | null;
  calculatedPendingBalance?: number | string | null;
  totalPaymentsCount?: number | string | null;
  firstSaleDate?: string | null;
  lastSaleDate?: string | null;
}

export interface SalesReportSale {
  saleId?: number | string | null;
  saleOrderCode?: string | null;
  saleShortCode?: string | null;
  saleDate?: string | null;
  saleEndPrice?: number | string | null;
  saleState?: number | string | null;
  clientNationalId?: string | number | null;
  nationalId?: string | number | null;
  identification?: string | number | null;
  clientName?: string | null;
  name?: string | null;
  shopCompanyName?: string | null;
  companyName?: string | null;
  association?: string | null;
  principalAmount?: number | string | null;
  termMonths?: number | string | null;
  firstInstallmentDate?: string | null;
  monthlyInstallment?: number | string | null;
  observations?: string | null;
  products?: string | null;
  [key: string]: unknown;
}

export interface SalesReportItem {
  saleId?: number | string | null;
  itemId?: number | string | null;
  productName?: string | null;
  quantity?: number | string | null;
  [key: string]: unknown;
}

export interface SalesReportExcelRow {
  identification?: string | number | null;
  name?: string | null;
  document?: string | number | null;
  date?: string | null;
  principalAmount?: number | string | null;
  discountAmount?: number | string | null;
  netAmount?: number | string | null;
  termMonths?: number | string | null;
  firstInstallmentDate?: string | null;
  monthlyInstallment?: number | string | null;
  observations?: string | null;
  [key: string]: unknown;
}

export interface SalesReportResponse {
  summary: SalesReportSummary;
  sales: SalesReportSale[];
  items: SalesReportItem[];
  excelRows: SalesReportExcelRow[];
  filters: SalesReportFilters;
}

export interface SalesReportPreviewRow {
  identification: string;
  client: string;
  order: string;
  date: string;
  association: string;
  principalAmount: number;
  termMonths: number | null;
  firstInstallmentDate: string;
  monthlyInstallment: number;
  observations: string;
}

export interface ValidatedSalesReportExcelRow extends SalesReportExcelRow {
  identification: string;
  name: string;
  date: string;
  principalAmount: number;
  discountAmount: number;
  netAmount: number;
  termMonths: number;
  firstInstallmentDate: string;
  monthlyInstallment: number;
  observations: string;
}

export interface ReportCatalogOption {
  id: number | string;
  name: string;
}
